import React from "react";
import { useIntl } from "react-intl";

const DCDDescriptionLiver = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="row mb-4">
      <div className="col-12">
        <div className="title pl-0">
          {formatMessage({ id: "utils.dcd.title" })}:
        </div>
        {formatMessage({ id: "utils.dcd.description.liver" })}
      </div>
    </div>
  );
};

export default DCDDescriptionLiver;
